// extracted by mini-css-extract-plugin
export default {"quote":"quote_quote__bMxlj","quoteTitle":"quote_quoteTitle__ddsVa","quoteText":"quote_quoteText__DO3q-","quoteImage":"quote_quoteImage__DLuHf"};